import React, { useCallback } from 'react';

import { Filter } from '@pkg/classes';
import { FilterChip } from '@pkg/components/filters';
import { truncateContractAddress } from '@pkg/utils';

import { splitCamelCase } from '@app/helpers';
import { useNFTsFiltersStore } from '@app/store/zustand';

export interface GeneralActionProps {
    // TODO: These should be strongly typed.
    filterKey?: string;
    filterOption?: string;
}

function getLabel({ filterKey = '', filterOption = '' }: GeneralActionProps) {
    if (filterKey === 'wallets') {
        const split = filterOption.split('.');
        return truncateContractAddress(split[split.length > 1 ? 1 : 0]);
    }

    return splitCamelCase(filterOption);
}

export function GeneralAction({ filterKey = '', filterOption = '' }: GeneralActionProps) {
    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();

    const label = getLabel({ filterKey, filterOption });
    const selected = currentFilters.hasSomeValue(filterKey, filterOption);

    const handleSelect = useCallback(() => {
        const updatedFilters = new Filter(currentFilters);
        updatedFilters.toggle(filterKey, filterOption);

        setCurrentFilters(updatedFilters);
    }, [currentFilters, filterKey, filterOption, setCurrentFilters]);

    return <FilterChip label={label} pressed={selected} onAction={handleSelect} />;
}
